import React, { useRef, useState, useEffect } from 'react';
import { Input, Dropdown } from 'semantic-ui-react';
import { ModifyDocument } from 'src/graphql/documents';
import { useDispatch } from 'react-redux';
import { importAlertState } from 'src/redux/actions/alert';
import { importUpdateCashflowNeeded } from 'src/redux/actions/flujocaja';
import { updateConcilieantionRatio } from 'src/redux/actions/dashboard';
import { setUpdateDocuments } from 'src/redux/actions/documentostributarios';
import moment from 'moment';
import { importUpdateNominaInProcessNeeded } from 'src/redux/actions/proveedores';
import CustomModal from '../../configuracion/components/customModal';

export const PostponeModal = ({ companyId, option, selected }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false)
  const [type, setType] = useState('date')
  const [value, setValue] = useState({ date: '', days: '' })
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setValue({ date: '', days: '' })
    setOpen(false)
    setNewDocumentDate(null);
  };

  const { executeMutation } = ModifyDocument()

  const options = [
    { key: 'date', text: 'Seleccionar fecha', value: 'date' },
    { key: 'days', text: 'Ingresar días', value: 'days' },
  ]

  const currenDocumentDate = selected[0]?.dueDate ? moment(selected[0]?.dueDate).format('DD/MM/YYYY') : ''

  const [newDocumentDate, setNewDocumentDate] = useState();
  
  useEffect(() => {
    const daysToAdd = Number(value?.days) || 0;
    if (daysToAdd == 0){
      setNewDocumentDate(null);
      return;
    };
    const newDate = moment(selected[0]?.dueDate).add(daysToAdd, 'days').format('DD/MM/YYYY');
  
    setNewDocumentDate(newDate);
  }, [value.days])
  

  const handleSubmit = async () => {
    try {
      const input = selected.map((document) => {
        const date = type === 'date' ? moment(value[type], 'YYYY-MM-DD').toDate() : moment(document.dueDate).add(value[type], 'days').toDate()
        return ({ id: document.id, fields: [{ key: 'dueDate', value: date }, { key: 'flowAction', value: 'postpone' }] })
      })
      const { data, error } = await executeMutation({ companyId, input })

      handleClose();

      if (error || data?.modifyDocument?.nModified === 0) {
        return dispatch(
          importAlertState({
            content: "Error al cambiar fecha de pago, intente nuevamente.",
            state: "error",
            duration: 3,
          })
        )
      }

      dispatch(importUpdateNominaInProcessNeeded({ value: true }))
      dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))
      dispatch(updateConcilieantionRatio());
      dispatch(setUpdateDocuments({ value: true }))

      dispatch(
        importAlertState({
          content: selected.length > 1 ? "Documentos modificados con éxito" : "Documento modificado con éxito",
          state: "success",
          duration: 3,
        })
      )
    } catch (error) {
      console.error(error);
    }
  }

  const onDropdownChange = (v) => {
    setType(v)
  }

  return (
    <>
      <Dropdown.Item value={option?.value} onClick={handleOpen}>
        {option?.text}
      </Dropdown.Item>
      <CustomModal
        open={open}
        onClose={handleClose}
        dimmer="blurring"
        size="tiny"
        title="Cambiar fecha"
        confirmLabel="Posponer"
        onConfirm={handleSubmit}
        confirmDisabled={!value[type]}
        content={
          <>
        <p>Seleccione la fecha o los días a posponer el pago</p>
        <br />
        <p style={{ display: currenDocumentDate ? undefined : 'none' }}>{` Fecha actual de pago: ${currenDocumentDate}`}</p>
        {
          newDocumentDate &&
          <p style={{ display: currenDocumentDate ? undefined : 'none' }}>{` Fecha nueva de pago: ${newDocumentDate}`}</p>
        }
        <br />
        <Input
          action={
            <Dropdown
              selectOnBlur={false}
              button
              basic
              floating
              options={options}
              defaultValue='date'
              onChange={(_, v) => onDropdownChange(v.value)}
            />
          }
          actionPosition="left"
          placeholder='Posponer pago...'
          onChange={(_, v) => setValue({ ...value, [type]: v.value })}
          type={type}
          value={value[type]}
        />
          </>
        }
      />
    </>
  );
};
